<template>
    <div v-title data-title="历史GIS与数字人文">
        <el-row class="header-hd">
            <el-col :span="5">
                <img class="img-logo" src="/static/img/logogis.png" alt="回到首页" />
                <img class="img-logo" src="/static/img/logo.png" alt="回到首页" style="margin-left: 0px" />
            </el-col>
            <el-col :span="isLoginSuccess ? 16 : 13" :offset="2" style="text-align: center">
                <div class="header-menu" style="float: left">
                    <el-menu :default-active="$store.state.V3menuActive" mode="horizontal" background-color="#12C287"
                        @select="handleSelect" text-color="#fff" active-text-color="white">
                        <el-menu-item index="5">项目说明</el-menu-item>
                        <el-menu-item index="4">原始数据</el-menu-item>

                        <el-menu-item index="2">数据下载</el-menu-item>
                        <el-menu-item index="6" v-if="adminAccountFlag">数据导出</el-menu-item>
                        <el-menu-item index="3" v-if="adminAccountFlag">数据审核</el-menu-item>
                        <el-menu-item index="1">首页</el-menu-item>
                    </el-menu>
                </div>
            </el-col>
            <el-col :span="isLoginSuccess ? 1 : 4" :class="isLoginSuccess ? 'userimgclass' : 'usertextclass'">

                <span v-if="!isLoginSuccess" style="cursor: pointer"
                    @click="$router.push({ name: 'login' })">游客，请登录&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span v-if="!isLoginSuccess" style="color: orange; cursor: pointer"
                    @click="$router.push({ name: 'register' })">免费注册</span>
                <el-popover placement="top-start" width="260" trigger="hover" v-if="isLoginSuccess">
                    <el-image style="width: 50px; height: 50px; cursor: pointer" src=" /static/images/默认头像.png"
                        slot="reference"></el-image>

                    <div class="Login_personal">
                        <el-row class="Login_header">
                            <span class="Login_username" @click="$router.push({ name: 'myAccount' })">{{
                                getUserName.substr(0, 3) +
                                '***' +
                                getUserName.substr(
                                    6,
                                    getUserName.split('').length
                                )
                            }}</span>
                            <i class="el-icon-arrow-right" @click="$router.push({ name: 'myAccount' })"></i>
                        </el-row>
                        <el-row class="Login_logout" style="text-align: center; background: #12c287">
                            <el-button type="text" style="
                                    font-size: 16px;
                                    line-height: 10px;
                                    color: white;
                                " @click="$router.push({ name: 'myAccount' })">查看个人信息</el-button></el-row>
                        <el-row class="Login_logout" style="text-align: center">
                            <el-button type="text" @click="logout()"
                                style="font-size: 16px; line-height: 10px">退出登录</el-button></el-row>
                    </div>
                </el-popover>
            </el-col>

        </el-row>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'comHeader',
    data() {
        return {
            adminAccountFlag: false,
        }
    },



    computed: {

        // V3版本
        isLoginSuccess: function () {
            if (
                this.$cookie.get('isLogin') == 'success' ||
                this.$store.state.V3loginState == true
            ) {
                return true
            } else {
                return false
            }
        },
        getUserName: function () {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },

    },
    mounted() {

        this.isAdminAccount()
    },

    methods: {
        getUser() {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        //判断是否是管理员用户
        isAdminAccount() {
            axios({
                url: $webConfig.V3.backendAPI + 'isAdminAccount',
                method: 'post',
                data: JSON.stringify({
                    mail: this.getUser(),
                }),
            }).then((res) => {
                if (res.data.role == '管理员') {
                    this.adminAccountFlag = true
                } else if (res.data.role == '普通用户') {
                    this.adminAccountFlag = false
                }
            })
        },

        // 点击 菜单项 首页 数据下载 数据审核 原始数据 项目说明

        handleSelect(key, keyPath) {
            this.$store.state.V3menuActive = key
            switch (key) {
                case '1':
                    this.$router.push({ name: 'home' })
                    break
                case '2':
                    this.$router.push({ name: 'dataDownload' })
                    break
                case '3':
                    this.$router.push({ name: 'check' })
                    break
                case '4':
                    this.$router.push({ name: 'originData' })
                    break
                case '5':
                    this.$router.push({ name: 'introduce' })
                    break
                case '6':
                    this.$router.push({ name: 'exportData' })
                    break
                case '7':
                    // this.$router.push({ name: 'DataDownload' })
                    break
                default:
                    break
            }
        },
        // 退出登录
        logout() {
            this.$cookie.set('mail', null)
            this.$cookie.set('isLogin', 'fail')
            this.$store.state.V3mail = ''
            this.$store.state.V3loginState = false
            this.$cookie.set('V3loginRole', null)
            this.$store.state.V3loginRole = ''
            this.$router.push({ name: 'home' })
            this.$store.state.V3menuActive = '1'
            location.reload()
        },
    },
}
</script>
<style scoped>
/* 头蓝色长条框样式 */
.header-hd {
    padding: 0;
    margin: 0;
    height: 80px;
    background-color: #12c287;

    color: #fff;
    font-family: '微软雅黑';
    font-size: 1.3rem;
    line-height: 3.8rem;
    text-align: left;
}

/* 图标 */
.img-logo {
    margin-top: 15px;
    margin-left: 30px;
    padding: 0;
    vertical-align: middle;
    /* width: 180px; */
    height: 50px;
}

.img-log1 {
    margin-top: 15px;
    /* margin-left: 30px; */
    padding: 0;
    vertical-align: middle;
    /* width: 180px; */
    height: 50px;
}

/* 菜单项 */
.header-menu {
    height: 80px;
}

/* 账户 */
.Login_personal {
    background-color: #fff;
}

.Login_header:hover {
    color: #12c287;
}

.Login_header {
    justify-content: start;
    padding: 10px;
    cursor: pointer;
}

.Login_username {
    font-size: 16px;
}

.Login_logout {
    border: 1px solid #eaeaea;
    margin-bottom: 10px;
    height: 36px;
    color: #12c287;
    cursor: pointer;
}

.userimgclass {
    line-height: 113px;
}

.usertextclass {
    line-height: 80px;
}
</style>




// WEBPACK FOOTER //
// src/V3/Header/comHeader.vue